/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Same_Muscle_EasierInputs */

const en_us2_prescription_reason_same_muscle_easier = /** @type {(inputs: Prescription_Reason_Same_Muscle_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works the same muscle and is easier`)
};

const pt_br2_prescription_reason_same_muscle_easier = /** @type {(inputs: Prescription_Reason_Same_Muscle_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalha o mesmo músculo e é mais fácil`)
};

const es_419_prescription_reason_same_muscle_easier = /** @type {(inputs: Prescription_Reason_Same_Muscle_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabaja el mismo músculo y es más fácil`)
};

const pt_pt2_prescription_reason_same_muscle_easier = /** @type {(inputs: Prescription_Reason_Same_Muscle_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalha o mesmo músculo e é mais fácil`)
};

const fr_fr2_prescription_reason_same_muscle_easier = /** @type {(inputs: Prescription_Reason_Same_Muscle_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travaille le même muscle et c'est plus facile`)
};

const de_de2_prescription_reason_same_muscle_easier = /** @type {(inputs: Prescription_Reason_Same_Muscle_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainiert denselben Muskel und ist leichter`)
};

const it_it2_prescription_reason_same_muscle_easier = /** @type {(inputs: Prescription_Reason_Same_Muscle_EasierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavora lo stesso muscolo ed è più facile`)
};

/**
* | output |
* | --- |
* | "Works the same muscle and is easier" |
*
* @param {Prescription_Reason_Same_Muscle_EasierInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_same_muscle_easier = /** @type {((inputs?: Prescription_Reason_Same_Muscle_EasierInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Same_Muscle_EasierInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_same_muscle_easier(inputs)
	if (locale === "es-419") return es_419_prescription_reason_same_muscle_easier(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_same_muscle_easier(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_same_muscle_easier(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_same_muscle_easier(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_same_muscle_easier(inputs)
	return en_us2_prescription_reason_same_muscle_easier(inputs)
});
export { prescription_reason_same_muscle_easier as "prescription.reason.same_muscle_easier" }